var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-0"},[_c('nv-show',{attrs:{"cols":"12","sm":"7","header":"Country Code"}},[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.proposed.country_code))+" ")]),_c('nv-show',{attrs:{"cols":"12","sm":"5","header":"Parent","no-placeholder":""}},[_c('tree-item',{attrs:{"tree-id":_vm.proposed.mv_parent_id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }